import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { space } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { useLocalization } from 'common/providers/LocaleProvider';
import { getAdditionalInfoEditLabel } from '../../../utils/getadditionalInfoEditLabel';
import EditButton from '../EditButton';
import PartNumbers from './PartNumbers';
import Pictures, { PicturesHeading } from './Pictures';
import VendorOrderId from './VendorOrderId';

export interface EditAdditionalInfoButtonProps {
  partNumbers: string[];
  resources: string[];
  isDisabled: boolean;
  vendorOrderId: Nullable<string>;
  onClick: (itemId: string) => void;
}

const StyledPartNumbers = styled(PartNumbers)<any>`
  ${space};
`;

const EditAdditionalInfoButton = ({
  partNumbers,
  resources,
  isDisabled,
  onClick,
  vendorOrderId,
}: EditAdditionalInfoButtonProps) => {
  const { t } = useLocalization();
  const hasPictures = resources.length > 0;

  return (
    <Flex justifyContent="space-between" alignItems="flex-start">
      <Flex flexDirection="column">
        <VendorOrderId vendorOrderId={vendorOrderId} />
        <StyledPartNumbers
          items={partNumbers}
          mt={!!vendorOrderId?.length ? 'sp_8' : {}}
          mb={!!resources.length ? 'sp_8' : {}}
        />
        {hasPictures && (
          <>
            <PicturesHeading />
            <Pictures items={resources} />
          </>
        )}
      </Flex>
      <EditButton
        dataTestId="edit-additional-info-button"
        ariaLabel={getAdditionalInfoEditLabel({
          t,
          vendorOrderId,
          partNumbers,
          pictureCount: resources?.length || 0,
        })}
        isDisabled={isDisabled}
        onClick={onClick}
      />
    </Flex>
  );
};

export default EditAdditionalInfoButton;
